import React, { useContext, useState, useEffect } from "react";
import { Container, Grid, Typography, Card, CardContent } from "@material-ui/core";
import PageTitle from "../../components/pageTitle/PageTitle";
import Appointments from "./components/Appointments";
import EmpRequests from "./components/EmpRequests";
import moment from "moment";
import Issues from "./components/Issues";
import Notifications from "./components/Notifications";
import ClientSummary from "./components/ClientSummary";
import EmployeeSummary from "./components/EmployeeSummary";
import BarChartOutlinedIcon from '@mui/icons-material/BarChartOutlined';
import ChatBubbleOutlineOutlinedIcon from '@mui/icons-material/ChatBubbleOutlineOutlined';
import Alerts from "./components/Communications/Alerts";
import IssuesList from "./components/Communications/IssuesList";
import AuthContext from "../../hooks/authContext";
import { useMediaQuery } from "@mui/material";
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../../components/Tabs/Tabs";
import TeamMessages from "./components/TeamMessages";
import ClientMessages from "./components/ClientMessages";
import SupportTickets from "./components/SupportTickets";
import { useLocation } from "react-router";
import { exchangeStripeCodes } from "../../services/apiservices/users";

const HomeContainer = (props) => {
  const [filterDate, setFilterDate] = useState(moment().format("YYYY-MM-DD"));
  const auth = useContext(AuthContext);
  const userPackageId = auth?.userProfile?.prdId;
  const [activeTab, setActiveTab] = useState("support");
  const isClient = auth?.userProfile?.role === "Client";
  const isMobile = useMediaQuery('(max-width:767px)');
  const location = useLocation();

  const handleDateChange = (newValue) => {
    setFilterDate(newValue.target.value);
  };
  const changeDate = (days) => {
    const newDate = moment(filterDate).add(days, "days").format("YYYY-MM-DD");
    setFilterDate(newDate);
  };

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const code = queryParams.get("code");

    if (code) {
      exchangeStripeCodes(code)
        .then((data) => {
          console.log("Stripe data saved and returned:", data);
        })
        .catch((err) => {
          console.error("Stripe exchange failed:", err);
        });
    }
  }, [location]);

  // const allowedPermissions = packageAccess(userPackageId);
  // const hasSupplyAccess =  allowedPermissions?.routes?.includes("SUPPLIES")
  // const hasIssueAccess = allowedPermissions?.routes?.includes("ISSUES");

  return (
    <>
      <Container>
        <PageTitle
          pageTitle="Dashboard"
          showBreadcrumb={[{ label: "Home", to: "/" }]}
          showLastSeen={true}
        />
        <div className="dashBoardCustom">
        <div data-tour="overview-section">
        <Grid container alignItems="center">
          <Grid item xs={12} sm={6}>
            <Typography variant="h6" className="text-gray-900 dark:text-white" style={{fontSize:"20px", lineHeight:"28px", fontWeight:"600"}}>
              <BarChartOutlinedIcon 
                className="color-lightGreen svg-icon mr-10"
              />
              Overview / Summary
            </Typography>
          </Grid>
          {/* <Grid item xs={12} sm={6}>
            <div className="d-flex groupsearch2 float-right">
              <div className="d-flex flex-center">
                <IconButton onClick={() => changeDate(-1)} className="p-4">
                    <ChevronLeft fontSize="large" className="text-black dark:text-white" />
                </IconButton>
                <TextField
                  name="date"
                  value={filterDate}
                  fullWidth={true}
                  size="small"
                  variant="outlined"
                  className={`field`}
                  type={"date"}
                  InputProps={{
                   classes: {
                     root: "bg-white dark:bg-[#1A1F2C] text-black dark:text-white",
                     input: "p-10",
                   },
                  }}
                  inputProps={{
                    className: "p-10",
                    min: moment().add(-30, "days").format("YYYY-MM-DD"),
                    max: moment().add(15, "days").format("YYYY-MM-DD"),
                  }}
                  onChange={handleDateChange}
                />
                <IconButton onClick={() => changeDate(1)} className="p-4">
                  <ChevronRight fontSize="large" className="text-black dark:text-white" />
                </IconButton>
              </div>
            </div>
          </Grid> */}
        </Grid>
        <Grid container spacing={2} className="mb-40" alignItems="stretch">
        <Grid item xs={12} md={isClient ? 6 : 3} lg={isClient ? 6 : 3}>
            <div className={`sectionBox h-stretch8 radius hover-effect dark:bg-[#1A1F2C] dark:text-white shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]`}>
              <Appointments />
            </div>
          </Grid>
          {!isClient && (
          <Grid item xs={12} md={3} lg={3}>
            <div className={`sectionBox h-stretch8 radius hover-effect dark:bg-[#1A1F2C] dark:text-white shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]`}>
              <EmpRequests />
            </div>
          </Grid>
          )}
          <Grid item xs={12} md={isClient ? 6 : 3} lg={isClient ? 6 : 3}>
            <div className={`sectionBox h-stretch8 radius hover-effect dark:bg-[#1A1F2C] dark:text-white shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]`}>
              <Issues />
            </div>
          </Grid>
          {!isClient && (
          <Grid item xs={12} md={3} lg={3}>
            <div className={`sectionBox h-stretch8 radius hover-effect dark:bg-[#1A1F2C] dark:text-white shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]`}>
              <Notifications />
            </div>
          </Grid>
          )}
        </Grid>
        </div>

        <Grid container spacing={3} className="mb-40" data-tour="daily-summary">
          <Grid item xs={12} md={12} lg={12}>
            <ClientSummary />
          </Grid>
        </Grid>
          <Grid container spacing={3} className="mb-20">
            <Grid item xs={12} md={12} lg={12} container alignItems="center">
              <Grid item xs={12} sm={6}>
                <Typography variant="h6"  className="text-gray-900 dark:text-white" style={{ fontSize:"20px", lineHeight:"28px", fontWeight:"600"}}>
                  <ChatBubbleOutlineOutlinedIcon
                    className="color-lightGreen mr-10 svg-icon"
                  />
                  Communication Channel
                </Typography>
              </Grid>
            </Grid>
          </Grid>

          <Card className="mb-20 dark:bg-[#1A1F2C] dark:text-white border border-[#e5e7eb] dark:border-0 shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]" data-tour="communication-messages">
            <CardContent className="pb-2">
              <Tabs defaultValue="messages">
                <TabsList>
                  <TabsTrigger value="messages">
                    <ChatBubbleOutlineIcon className="icon" />
                    <span className="label">Messages</span>
                  </TabsTrigger>
                  <TabsTrigger value="support">
                    <ErrorOutlineIcon className="icon" />
                    <span className="label">Support</span>
                  </TabsTrigger>
                </TabsList>
                <TabsContent value="messages">
                  <div className={isMobile ? "" : "d-flex"}>
                  <Grid item xs={12} md={isClient ? 6 : 4} lg={isClient ? 6 : 4}>
                        <div className="mt-8 mb-15 mh-5" style={{height:"100%"}}>
                          <TeamMessages />
                        </div>
                      </Grid>
                  <Grid item xs={12} md={isClient ? 6 : 4} lg={isClient ? 6 : 4}>
                        <div className="mt-8 mb-15 mh-5" style={{height:"100%"}}>
                          <ClientMessages />
                        </div>
                      </Grid>
                    {!isClient && (
                      <Grid item xs={12} md={4} lg={4}>
                        <div className="mt-8 mb-15 mh-5" style={{height:"100%"}}>
                          <Alerts />
                        </div>
                      </Grid>
                    )}
                  </div>
                </TabsContent>
                <TabsContent value="support">
                  <div className={isMobile ? "" : "d-flex"}>
                      <Grid item xs={12} md={isClient ? 12 : 4} lg={isClient ? 12 : 4}>
                        <div className="mt-8 mb-15 mh-5" style={{ height: "100%" }}>
                          <IssuesList />
                        </div>
                      </Grid>
                    {!isClient && (
                      <>
                      <Grid item xs={12} md={4} lg={4}>
                        <div className="mt-8 mb-15 mh-5" style={{ height: "100%" }}>
                          <EmployeeSummary />
                        </div>
                      </Grid>
                    <Grid item xs={12} md={4} lg={4}>
                      <div className="mt-8 mb-15 mh-5" style={{ height: "100%" }}>
                        <SupportTickets />
                      </div>
                    </Grid>
                    </>
                    )}
                  </div>
                </TabsContent>
              </Tabs>
            </CardContent>
          </Card>
          {/* {!isClient && (
          <Grid item xs={12} md={(hasSupplyAccess || hasIssueAccess) ? 4 : 6} lg={(hasSupplyAccess || hasIssueAccess) ? 4 : 6}>
            <div className={`sectionBox h-stretch9 radius shadow`}>
              <Alerts />
            </div>
          </Grid>
          )} */}
          {/* <Grid item xs={12} md={isClient ? 6 : (hasSupplyAccess || hasIssueAccess) ? 4 : 6} lg={isClient ? 6 : (hasSupplyAccess || hasIssueAccess) ? 4 : 6}>
            <div className={`sectionBox h-stretch9 radius shadow`}>
              <NotificationsList />
            </div>
          </Grid> */}
          {/* {hasIssueAccess && (
          <Grid item xs={12} md={isClient ? 6 : 4} lg={isClient ? 6 : 4}>
            <div className={`sectionBox h-stretch9 radius shadow`}>
              <IssuesList />
            </div>
          </Grid>
          )} */}

        </div>
        {/* {!isClient && hasSupplyAccess && (
        <Grid container spacing={3}>
          <Grid item xs={12} md={12} lg={12} className="mb-20">
            <EmployeeSummary />
          </Grid>
        </Grid>
        )} */}
      </Container>
    </>
  );
};

export default HomeContainer;
